import "./Company.module.css";
import Header from "@/reusable_sections/Header";
import Mission from "./sections/Mission";
import Safety from "./sections/Safety";
import Footer from "@/reusable_sections/Footer";
export default function CompanyPage() {
  return <div>
      <Header />
      <Mission />
      <Safety />
      <Footer />
    </div>;
}